export default __webpack_public_path__ + "static/media/anastasia.89bbb94b.jpg";